const SET_UI_STATE = 'SET_UI_STATE';
const SET_NOTIFICATION_STATE = 'SET_NOTIFICATION_STATE';

const defaultState = {
  uiState: null, // loading | empty | complete | error | null
  notification: { open: false }
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_UI_STATE:
      return { ...state, uiState: action.payload };
    case SET_NOTIFICATION_STATE:
      return { ...state, notification: action.payload };

    default:
      return state;
  }
}

export function setUiState(uiState) {
  return {
    type: SET_UI_STATE,
    payload: uiState
  };
}

export function showNotification(notification) {
  return {
    type: SET_NOTIFICATION_STATE,
    payload: { open: true, ...notification }
  };
}

export function closeNotification() {
  return {
    type: SET_NOTIFICATION_STATE,
    payload: { open: false }
  };
}



// WEBPACK FOOTER //
// ./src/redux/ui.js